import React from 'react';

const EditInvoice = ({ formData, handleInputChange, saveEdit, closeModal }) => {
    return (
        <div className="p-6 max-w-lg mx-auto bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-4">Edit Installment</h2>

            <div className="space-y-4">
                <div>
                    <label htmlFor="invoice_date" className="block text-sm font-medium text-gray-700">Invoice Date</label>
                    <input
                        id="invoice_date"
                        name="invoice_date"
                        type="date"
                        required
                        value={new Date(formData.invoice_date).toISOString().split('T')[0]}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="sub_total" className="block text-sm font-medium text-gray-700">Sub Total</label>
                    <input
                        id="sub_total"
                        name="sub_total"
                        type="number"
                        required
                        value={formData.sub_total}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="discount" className="block text-sm font-medium text-gray-700">Discount</label>
                    <input
                        id="discount"
                        name="discount"
                        type="number"
                        required
                        value={formData.discount}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="discount_type" className="block text-sm font-medium text-gray-700">Discount Type</label>
                    <input
                        id="discount_type"
                        name="discount_type"
                        type="text"
                        required
                        value={formData.discount_type}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="taxes" className="block text-sm font-medium text-gray-700">Taxes</label>
                    <input
                        id="taxes"
                        name="taxes"
                        type="text"
                        required
                        value={formData.taxes}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="payment_due_date" className="block text-sm font-medium text-gray-700">Payment Due Date</label>
                    <input
                        id="payment_due_date"
                        name="payment_due_date"
                        type="date"
                        required
                        value={new Date(formData.payment_due_date).toISOString().split('T')[0]}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="total_amount" className="block text-sm font-medium text-gray-700">Total Amount</label>
                    <input
                        id="total_amount"
                        name="total_amount"
                        type="number"
                        required
                        value={formData.total_amount}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>
                <div>
                    <label htmlFor="payment_status" className="block text-sm font-medium text-gray-700">Payment Status</label>
                    <input
                        id="payment_status"
                        name="payment_status"
                        type="text"
                        required
                        value={formData.payment_status}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="payment_terms" className="block text-sm font-medium text-gray-700">Payment Terms</label>
                    <input
                        id="payment_terms"
                        name="payment_terms"
                        type="text"
                        required
                        value={formData.payment_terms}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="notes" className="block text-sm font-medium text-gray-700">Notes</label>
                    <input
                        id="notes"
                        name="notes"
                        type="text"
                        required
                        value={formData.notes}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>

                <div>
                    <label htmlFor="invoice_status" className="block text-sm font-medium text-gray-700">Invoice Status</label>
                    <input
                        id="invoice_status"
                        name="invoice_status"
                        type="text"
                        required
                        value={formData.invoice_status}
                        onChange={handleInputChange}
                        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                </div>
            </div>

            <div className="flex justify-between mt-4">
                <button
                    onClick={closeModal}
                    className="bg-gray-500 text-white px-4 py-2 rounded-md"
                >
                    Cancel
                </button>
                <button
                    onClick={saveEdit}
                    className="bg-blue-600 text-white px-4 py-2 rounded-md"
                >
                    Save Changes
                </button>
            </div>
        </div>
    );
};

export default EditInvoice;
